import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import BaseFooter from '&/components/BaseFooter';
import BaseHeader from '&/components/BaseHeader';
import SignUpDlg from '&/components/Dialogs/SignUpDlg';
import SignInDlg from '&/components/Dialogs/SignInDlg';
import ApplyTrialDlg from '&/components/Dialogs/ApplyTrialDlg';
import ResetPage from '&/components/ResetPage';
import Routers from './routerMap';
import { inject, observer } from 'mobx-react';
import PreviewPDF from '&/pages/PreviewPDF/PreviewPdfMini';
import BindEmail from '@/pages/user-center/BindEmail';
import TDK from '&/components/TDK';
import LicensePage from '@/pages/hdd-license-page';
import HddSignIn from '@/pages/login-pages/HddSignIn';
import HddOrganizationSelect from '@/pages/login-pages/HddOrganizationSelect';
import HDD_ROUTE_LIST from './hddRouter';
import APP_ROUTE_LIST from './appRouter';
import { redirectList } from '@/constants';
import DesignPreview from '&/pages/design-preview';
import Panorama from '&/pages/home-page/ExcellentDesign/panorama';
import PanoramaShare from '&/pages/panorama-share';
import FloorPlanPreview from '&/pages/floor-plan-design/preview';
import Agree from '&/pages/floor-plan-design/agree';

function Container(props) {
    const { appStore } = props;
    const { setLoginData } = appStore;

    const routerRender = props => {
        const { search, pathname } = props.location;
        const params = new URLSearchParams(search);
        //  H5打开
        const isWcp = params.get('type') === 'wcp';
        const isFreeUse = params.get('from') === 'freeUse';
        const combination = params.get('c');
        if (
            (redirectList.includes(pathname) ||
                ['/user-center'].includes(props.match.path)) &&
            !appStore.isLogIn &&
            !isWcp
        ) {
            isFreeUse && appStore.setIsFreeUseLogin(true);
            !combination &&
                props.history.push(
                    '/login/signin?redirect=' +
                        encodeURIComponent(pathname + search)
                );
            return false;
        } else {
            return true;
        }
    };

    const hddRouterRender = props => {
        const { search } = props.location;
        const params = new URLSearchParams(search);
        const token = params.get('token');
        if (token) {
            setLoginData({ token, userinfo: {} }, false);
        }
        return true;
    };

    return (
        <BrowserRouter>
            <ResetPage />
            <Switch>
                <Route
                    path={'/preview-pdf'}
                    render={props => {
                        if (routerRender(props)) {
                            return <PreviewPDF {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/hdd-login'}
                    render={props => {
                        if (routerRender(props)) {
                            return <HddSignIn {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/hdd-select-organization'}
                    render={props => {
                        if (routerRender(props)) {
                            return <HddOrganizationSelect {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/bind-email'}
                    render={props => {
                        if (routerRender(props)) {
                            return <BindEmail {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/portal/products/hdd'}
                    render={props => {
                        if (routerRender(props)) {
                            return <LicensePage {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/home/panorama/:id'}
                    render={props => {
                        if (routerRender(props)) {
                            return <Panorama {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/home/floorPlan/preview/:id'}
                    render={props => {
                        if (routerRender(props)) {
                            return <FloorPlanPreview {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/home/floorPlan/agree'}
                    render={props => {
                        if (routerRender(props)) {
                            return <Agree {...props} />;
                        }
                    }}
                />

                {HDD_ROUTE_LIST.map((item, index) => (
                    <Route
                        key={index}
                        path={item.path}
                        render={props => {
                            if (hddRouterRender(props)) {
                                return (
                                    <>
                                        <item.component {...props} />
                                    </>
                                );
                            }
                        }}
                    />
                ))}
                {APP_ROUTE_LIST.map((item, index) => (
                    <Route
                        key={index}
                        path={item.path}
                        render={props => {
                            if (hddRouterRender(props)) {
                                return (
                                    <>
                                        <item.component {...props} />
                                    </>
                                );
                            }
                        }}
                    />
                ))}
                <Route
                    path={'/design/preview'}
                    render={props => {
                        if (routerRender(props)) {
                            return <DesignPreview {...props} />;
                        }
                    }}
                />
                <Route
                    path={'/panorama/share'}
                    render={props => {
                        if (hddRouterRender(props)) {
                            return <PanoramaShare {...props} />;
                        }
                    }}
                />
                <React.Fragment>
                    {!appStore.isTabletLandingPage && (
                        <BaseHeader
                            addClass={
                                appStore.isNeedMobile ? 'mobile-hd-layout' : ''
                            }
                        />
                    )}
                    <SignUpDlg />
                    <SignInDlg />
                    <ApplyTrialDlg />
                    <div
                        className={`hd-layout ${
                            appStore.isNeedMobile ? 'mobile-hd-layout' : ''
                        } ${
                            appStore.isTabletLandingPage ? 'pad-hd-layout' : ''
                        }`}>
                        <Switch>
                            {Routers.map((item, index) => (
                                <Route
                                    key={index}
                                    path={item.path}
                                    render={props => {
                                        if (routerRender(props)) {
                                            return (
                                                <>
                                                    <TDK
                                                        location={
                                                            props.location
                                                        }></TDK>

                                                    <item.component
                                                        {...props}
                                                    />
                                                </>
                                            );
                                        }
                                    }}
                                />
                            ))}
                            <Redirect to="/home" />
                        </Switch>
                    </div>
                    {!appStore.isTabletLandingPage && (
                        <BaseFooter
                            addClass={
                                appStore.isNeedMobile ? 'mobile-hd-layout' : ''
                            }
                        />
                    )}
                </React.Fragment>
            </Switch>
        </BrowserRouter>
    );
}
export default inject('appStore')(observer(Container));
